const shippingCosts = {
  title: 'Versandkosten',
  altTitle: 'Paketversand',
  country: {
    germany: {
      title: 'Deutschland',
      types: {
        packet: {
          desc: 'bis 30 kg (Paket)',
          code: 'V01',
          price: null,
          id: 1
        },
        shipper: {
          desc: 'ab 30 kg (Spedition)',
          code: 'V02',
          price: null,
          id: 2
        },
        island: {
          desc: 'ggf. Inselzuschlag',
          code: 'V03',
          price: null,
          id: 3
        }
      },
      id: 1
    },
    eu: {
      title: 'Österreich',
      types: {
        packet: {
          desc: 'bis 30 kg (Paket)',
          code: 'V04',
          price: null,
          id: 4
        },
        shipper: {
          desc: 'ab 30 kg (Spedition)',
          code: 'V05',
          price: null,
          id: 5
        }
      },
      id: 2
    }
  }
}

export default {
  shippingCosts
}
